module.exports = __webpack_public_path__ + "img/annual_fee_excellent.25f0b0e8.png";